import script from "./Dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./Dialog.vue?vue&type=script&setup=true&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=0fd0cd91&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fd0cd91"]])

export default __exports__